import {
  IoMenuSharp,
  IoOptionsSharp,
  IoSettingsSharp,
  IoWarningSharp,
} from "react-icons/io5";
import {
  colors,
  fontSize,
  responsiveness,
} from "../../assets/styles/parameters";
import { useDispatch, useSelector } from "react-redux";

import styled from "styled-components";
import { toggleNav } from "../../redux/nav";

export const Navigation = () => {
  const dispatch = useDispatch();
  const { open } = useSelector((state) => state.nav);

  const today = new Date().toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  return (
    <BaseNav>
      {/* Hamburger — visible on mobile and tablet (≤1024px) only */}
      <HamburgerButton
        onClick={() => dispatch(toggleNav())}
        aria-label={open ? "Close menu" : "Open menu"}
        aria-expanded={open}
      >
        <IoMenuSharp />
      </HamburgerButton>

      <DateChip>
        <span>{today}</span>
      </DateChip>
      <BaseIconContainer>
        <li>
          <IoOptionsSharp />
        </li>
        <li>
          <IoWarningSharp />
        </li>
        <li>
          <IoSettingsSharp />
        </li>
      </BaseIconContainer>
    </BaseNav>
  );
};

export default Navigation;

const BaseNav = styled.nav`
  grid-area: navigation;
  font-size: ${fontSize.nav};
  height: min-content;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
  width: 100%;

  @media screen and (max-width: 1024px) {
    padding: 0.5rem 0.75rem;
    gap: 0.5rem;
  }
`;

/* Hamburger — hidden on desktop, visible on mobile/tablet */
const HamburgerButton = styled.button`
  display: none;
  background: transparent;
  border: none;
  color: ${colors.blue};
  font-size: 1.6rem;
  cursor: pointer;
  padding: 0.4rem;
  border-radius: 4px;
  flex-shrink: 0;
  line-height: 1;

  &:hover {
    background-color: ${colors.gray200};
  }

  @media screen and (max-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const DateChip = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
  color: #4b5563;
  font-weight: 500;
  font-size: 14px;
`;

const BaseIconContainer = styled.ul`
  display: flex;
  width: 100%;
  align-items: end;
  padding: 1rem 0 0.3rem;
  justify-content: flex-end;

  li {
    display: flex;
    align-items: center;
    background-color: ${colors.gray300};
    padding: 0.7rem;
    border-radius: 5px;
    margin-left: 0.5rem;
  }

  @media screen and (max-width: 1024px) {
    width: auto;
    padding: 0.3rem 0;
    flex-shrink: 0;
  }
`;
